import { Controller } from "@hotwired/stimulus";
import CustomizationRequest from "../site_builder/customization/request";

export default class extends Controller {
  static targets = ["searchInput", "clearButton", "categoryPanel"];

  connect() {
    this.previousCategory = this.getSelectedCategory();
    this.updateClearButton();
  }

  setCategory(event) {
    event.preventDefault();
    this.previousCategory = event.target.dataset.categoryKey;
  }

  search(e) {
    const tabType = e.target.closest("form").querySelector('input[name="tab_type"]').value;

    $(e.target).typeWatch({
      wait: 750,
      captureLength: 1,
      callback: async (value) => {
        const $form = $(e.target).closest("form");

        if (tabType === "icons") {
          if (value && value.trim().length > 0) {
            $form.find('input[name="category_key"]').val('seeAll');
            this.deselectCategories();
          } else {
            $form.find('input[name="category_key"]').val(this.previousCategory);
            this.selectCategory(this.previousCategory);
          }
        }

        const url = `${$form.attr("action")}?${$form.serialize()}`;
        await CustomizationRequest.turboFetch(url);
        this.updateClearButton();
      },
    });
  }

  preventSubmit(event) {
    event.preventDefault();
  }

  clearSearch() {
    this.searchInputTarget.value = "";
    this.searchInputTarget.dispatchEvent(new Event("input"));
    this.updateClearButton();
  }

  updateClearButton() {
    if (this.searchInputTarget.value.trim() === "") {
      this.clearButtonTarget.classList.add("hidden");
    } else {
      this.clearButtonTarget.classList.remove("hidden");
    }
  }

  deselectCategories() {
    this.categoryPanelTarget.querySelectorAll(".image.active").forEach((el) => {
      el.classList.remove("active");
    });
  }

  selectCategory(categoryKey) {
    if (!categoryKey) return;
    const categoryElement = this.categoryPanelTarget.querySelector(
      `a[href*="category_key=${categoryKey}"]`
    );
    if (categoryElement) {
      categoryElement.closest("li").classList.add("active");
    }
  }

  getSelectedCategory() {
    const activeCategory = this.categoryPanelTarget.querySelector(".image.active a");
    return activeCategory ? new URL(activeCategory.href).searchParams.get("category_key") : null;
  }
}
